import {
  ShoppingCart,
  UserCheck,
  ClipboardList,
  Banknote,
  Monitor,
  UserCog,
  Handshake,
  MessageSquare,
  Calculator,
  RefreshCcw,
  BarChart3,
  Briefcase,
  Cpu,
  Crown,
  Scale,
  Gavel,
  Heart,
  Rocket,
  Wallet,
  GraduationCap,
  Clock,
  Building2,
  Code2,
  Lightbulb,
  Globe,
  Truck,
  Users,
  Megaphone,
  ClipboardCheck,
  FileSpreadsheet,
  Factory,
  FolderKanban,
  ShieldCheck,
  Headphones,
  Leaf,
  Building,
  Brain,
  Laptop,
  Languages,
  BarChart,
  Presentation,
  FileText,
  Database,
  Mic,
} from "lucide-react";

const iconeAddCatalogue = {
  "Achats": ShoppingCart,
  "Assistant(e)": UserCheck,
  "Audit - Organisation - Conseil": ClipboardList,
  "Banque": Banknote,
  "Bureautique - PAO": Monitor,
  "Coaching": UserCog,
  "Commercial - Vente": Handshake,
  "Communication": MessageSquare,
  "Comptabilité - Fiscalité": Calculator,
  "Conduite du changement": RefreshCcw,
  "Contrôle de gestion": BarChart3,
  "Création d'entreprise": Briefcase,
  "Digital": Cpu,
  "Direction": Crown,
  "Droit": Scale,
  "Droit des affaires": Gavel,
  "Développement personnel": Heart,
  "Efficacité professionnelle": Rocket,
  "Finance - Trésorerie": Wallet,
  "Formation": GraduationCap,
  "Gestion du temps": Clock,
  "Immo & Services généraux": Building2,
  "Informatique - SI": Code2,
  "Innovation - Créativité": Lightbulb,
  "International": Globe,
  "Logistique": Truck,
  "Management": Users,
  "Marketing": Megaphone,
  "Organisation - Audit": ClipboardCheck,
  "Paie/Admin du personnel": FileSpreadsheet,
  "Production": Factory,
  "Projet": FolderKanban,
  "Qualité-Santé-Sécurité-Environnement": ShieldCheck,
  "Relation client": Headphones,
  "Développement durable": Leaf,
  "Secteur public": Building,
  "Soft skills": Brain,
  "Travail à distance": Laptop,
  "Langue": Languages,
  "Bureautique Microsoft Excel": FileSpreadsheet,
  "Bureautique Microsoft Power BI": BarChart,
  "Bureautique Microsoft Powerpoint": Presentation,
  "Bureautique Microsoft Word": FileText,
  "Bureautique Microsoft Access": Database,
  "Art Oratoire": Mic,
};

export default iconeAddCatalogue;
